export const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  appTheme: process.env.REACT_APP_THEME,
  extAuthUrl: process.env.REACT_APP_EXT_AUTH_URL,
  rtkAuthUrl: process.env.REACT_APP_RTK_AUTH_URL,
};

export default config;
